import { TableSorting } from '@src/types'
import { AxiosRequestConfig } from 'axios'
import { api, ApiRes } from './client'

export type WebhookCall = {
    id: string
    platform_name: string
    webhook: {
        id: string
        url: string
        action: string
    }
    action: string
    url: string
    payload: {
        [key: string]: any
    }
    response: string | null
    status: string
    error_message: string | null
    attempt_number: number
    attempted_at: string // ISO datetime
    succeeded_at: string | null // ISO datetime or null
    failed_at: string | null // ISO datetime or null
    created_at: string // ISO datetime
    updated_at: string // ISO datetime
}

export type WebhookCallsResponse = {
    success: string
    webhook_calls: WebhookCall[]
    webhook_calls_count: number
}

export const getWebhookCalls = (
    filters?: Record<string, unknown>,
    page?: number,
    limit?: number,
    sorting?: TableSorting[]
): ApiRes<WebhookCallsResponse> => {
    const config: AxiosRequestConfig = {}

    config.params = {}

    if (filters && Object.keys(filters).length) {
        config.params = filters
    }

    if (typeof page === 'number' && typeof limit === 'number') {
        config.params['range'] = page * limit - limit + '-' + page * limit
    }

    if (sorting && sorting.length) {
        config.params['sort'] = sorting
            .map((sort) => {
                return (sort.direction === 'desc' ? '-' : '') + sort.field
            })
            .join(',')
    }

    return api.get('v2/manage/webhook-calls', config)
}

export const retryWebhookCalls = (
    webhook_ids: string[]
): ApiRes<{ message: string }> => {
    return api.post('v2/manage/webhook-calls/retry', {
        webhook_call_ids: webhook_ids,
    })
}
